import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { LoggingService } from '../../shared/services/logging/logging.service';
import * as fromAccountAllocation from '.';

const log = new LoggingService();

export const AccountAllocationRoute: Ng2StateDeclaration = {
    // name: 'AccountAllocation.**'
    name: 'account.allocations',
    url: '/allocations',
    // , loadChildren: () => import('./payroll-item.module').then(r => r.AccountAllocationModule)
    component: fromAccountAllocation.AccountAllocationsContainerComponent
};
